import { RefField, createRefField } from "@ukam/core/models/ref-field";
export interface RecordLog {
  createdAt?: string;
  createdBy?: RefField;
  updatedAt?: string;
  updatedBy?: RefField;
  recordVersion?: number;
  recordDate?: string;
}

export function createRecordLog(data?: Partial<RecordLog>): RecordLog {
  return {
    createdAt: data?.createdAt,
    createdBy: data?.createdBy ?? createRefField(),
    updatedAt: data?.updatedAt,
    updatedBy: data?.updatedBy ?? createRefField(),
    recordVersion: data?.recordVersion,
    recordDate: data?.recordDate,
  };
}
